module.exports = __webpack_public_path__ + "01_long_brown.dc10c464.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_long_brown.png
// module id = BbDW
// module chunks = 0